<div class="header">
  <div class="col-xs-9 header-left-col">
    <fw-layout-group>
      <fw-section-heading [title]="'conflictFiles.header.reviewConflicts' | translate"
        [backButton]="true"></fw-section-heading>

      <fw-layout-group>
        <h4 class="actions-title">{{ 'common.labels.actions' | translate }}</h4>

        <mat-form-field class="actions" appearance="outline">
          <mat-select class="actions-select" [placeholder]="'conflictFiles.header.selectAction' | translate"
            [(ngModel)]="globalAction" (selectionChange)="updateConflictActions()"
            [disabled]="selectedConflicts.length === 0">
            <mat-select-trigger *ngIf="globalAction">
              {{ 'conflictFiles.resolveMethods.' + globalAction | translate }}
            </mat-select-trigger>
            <mat-option *ngFor="let option of getGlobalResolveOptions()" [value]="option.value"
              matTooltipPosition="left">
              <div class="action-option">
                <p class="action-label">{{ option.title }}</p>
                <p class="action-hint">{{ option.description }}</p>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </fw-layout-group>
    </fw-layout-group>
  </div>

  <div class="col-xs-3 header-right-col">
    <fw-button color="primary" (click)="resolveConflicts()" [disabled]="!selectedConflictsReady">
      {{ 'conflictFiles.header.resolveConflict' | translate }}
    </fw-button>
  </div>
</div>

<div class="body">
  <div class="col-xs-9 body-left">
    <div class="card">
      <div class="card-content">
        <mat-table class="no-margin-width" matSort matSortActive="level" matSortDirection="asc" matSortDisableClear
          [dataSource]="conflicts$" [trackBy]="trackById">
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
              <mat-checkbox class="actions-title" (change)="updateGlobalControls(true)"
                [(ngModel)]="allConflictsSelected"></mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let conflict" (click)="conflict">
              <mat-checkbox (change)="updateGlobalControls(false)" [(ngModel)]="conflict.selected"></mat-checkbox>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="fileDestination">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <mat-form-field appearance="outline" (click)="$event.stopPropagation()">
                <input matInput [formControl]="filters.controls['uploadPath']"
                  placeholder="{{ 'conflictFiles.table.fileDestinationHeader' | translate }}">
              </mat-form-field>
            </mat-header-cell>
            <mat-cell *matCellDef="let conflict">
              <div class="file-path">
                <fw-tooltip class="path-tooltip" position="below" [maxWidth]="300" [title]="conflict.upload_path">
                  <div class="path-wrapper">
                    <fw-ellipsis class="path-chunk" *ngIf="conflict.upload_metadata.subject"
                      [text]="conflict.upload_metadata.subject.label + '/'" [tooltipDisabled]="true"></fw-ellipsis>
                    <fw-ellipsis class="path-chunk" *ngIf="conflict.upload_metadata.session"
                      [ngClass]="conflict.level === conflictLevelEnum.Session || conflict.level === conflictLevelEnum.Acquisition || conflict.level === conflictLevelEnum.File ? '' : 'dimmed'"
                      [text]="conflict.upload_metadata.session.label + '/'" [tooltipDisabled]="true"></fw-ellipsis>
                    <fw-ellipsis class="path-chunk" *ngIf="conflict.upload_metadata.acquisition"
                      [ngClass]="conflict.level === conflictLevelEnum.Acquisition || conflict.level === conflictLevelEnum.File? '' : 'dimmed'"
                      [text]="conflict.upload_metadata.acquisition.label + '/'" [tooltipDisabled]="true"></fw-ellipsis>
                    <fw-ellipsis class="path-chunk"
                      [ngClass]="conflict.level === conflictLevelEnum.File ? '' : 'dimmed'"
                      [text]="conflict.upload_metadata.file.name" [tooltipDisabled]="true"></fw-ellipsis>
                  </div>
                </fw-tooltip>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="level">
            <mat-header-cell class="full-width" *matHeaderCellDef mat-stroked-button mat-sort-header>
              <mat-form-field appearance="outline" (click)="$event.stopPropagation()">
                <mat-select [formControl]="filters.controls['level']"
                  [placeholder]="'conflictFiles.table.typeOfConflictHeader' | translate">
                  <mat-option *ngFor="let option of conflictTypeOptions"
                    [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
              </mat-form-field>
            </mat-header-cell>
            <mat-cell *matCellDef="let conflict">
              <fw-chip color="orange" [title]="'conflictFiles.conflictLevels.' + conflict.level | translate"></fw-chip>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef mat-stroked-button>
              <h5>{{ 'common.labels.action' | translate }}</h5>
            </mat-header-cell>
            <mat-cell *matCellDef="let conflict">
              <mat-form-field *ngIf="typeResolveOptions" appearance="outline">
                <mat-select [placeholder]="'conflictFiles.table.selectAction' | translate"
                  [(ngModel)]="conflict.action">
                  <mat-select-trigger *ngIf="conflict.action">
                    {{ 'conflictFiles.resolveMethods.' + conflict.action | translate }}
                  </mat-select-trigger>
                  <mat-option *ngFor="let option of typeResolveOptions.get(conflict.type)" [value]="option.value">
                    <div class="action-option">
                      <p class="action-label">{{ option.title }}</p>
                      <p class="action-hint">{{ option.description }}</p>
                    </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actionError">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let conflict">
              <fw-tooltip *ngIf="conflict.action_error" [title]="conflict.action_error" position="below">
                <fw-icon class="action-error">warning</fw-icon>
              </fw-tooltip>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let conflict; columns: displayedColumns;" (click)="focusedConflict = conflict"
            [ngClass]="{ 'focused-conflict': focusedConflict && conflict._id === focusedConflict._id }"></mat-row>

          <div *matNoDataRow class="blank-state">
            <ng-container *ngIf="isLoading; else emptyState">
              <fw-loading></fw-loading>
            </ng-container>
            <ng-template #emptyState>
              <fw-icon class="sm raised bright-blue">list-paragraph</fw-icon>
              <p>{{ 'conflictFiles.states.empty' | translate }}</p>
            </ng-template>
          </div>
        </mat-table>
      </div>
      <div class="card-footer">
        <div>
          <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
          <mat-paginator [length]="total" [pageSize]="25" [pageSizeOptions]="[5, 25, 50, 100]" [disabled]="isLoading"
            aria-label="Select page">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xs-3 body-right" *ngIf="focusedConflict">
    <div class="card animated fadeInRight">
      <fw-alert [description]="'conflictFiles.conflictTypes.' + focusedConflict.type | translate"
        [icon]="'information-circle'" [severity]="'warning'"
        [title]="'conflictFiles.conflictLevels.' + focusedConflict.level | translate" [variant]="'standard'">
      </fw-alert>

      <fw-section-heading [description]="'conflictFiles.details.sourceFilePath' | translate">
        <fw-tooltip [title]="'conflictFiles.details.tooltips.copyFirstPath' | translate" [position]="'left'"
          [maxWidth]="250">
          <fw-button (click)="copyPathToClipboard(focusedConflict)" variant="ghost" color="primary"
            [leftIcon]="'copy-item'">{{ 'conflictFiles.details.copyPath' | translate }}</fw-button>
        </fw-tooltip>
      </fw-section-heading>

      <fw-ellipsis [text]="import.storage.url + ('/' + focusedConflict.upload_metadata.storage_prefix
       + '/' + focusedConflict.upload_metadata.storage_paths[0]).replaceAll('//', '/')">
      </fw-ellipsis>

      <ul class="wrapper">
        <ng-container *ngFor="let path of focusedConflict.upload_metadata.storage_paths; let i = index">
          <li *ngIf="i < 3 || shouldShowAllPaths">
            <fw-ellipsis [text]="path"></fw-ellipsis>
          </li>
        </ng-container>
      </ul>

      <fw-button variant="ghost" color="primary" (click)="shouldShowAllPaths = !shouldShowAllPaths"
        *ngIf="focusedConflict.upload_metadata.storage_paths.length > 3">
        {{ shouldShowAllPaths ? ('conflictFiles.details.hideAll' | translate) : ('conflictFiles.details.seeAll' | translate) }}
        ({{ focusedConflict.upload_metadata.storage_paths.length }})
      </fw-button>

      <fw-section-heading [description]="'conflictFiles.details.conflictingFields' | translate"></fw-section-heading>

      <div class="conflicting-fields">
        <ng-container *ngFor="let field of focusedConflict.fields | keyvalue">
          <div *ngIf="isVisibleField(field.key)" class="conflicting-field">
            <p>{{ 'conflictFiles.conflictedFields.' + focusedConflict.level + '.' + field.key | translate }}</p>
            <fw-ellipsis [text]="field.value"></fw-ellipsis>
          </div>
        </ng-container>
      </div>

      <fw-section-heading>
        <fw-tooltip [title]="'conflictFiles.details.tooltips.executeFwContainerSearch' | translate" [maxWidth]="250"
          [position]="'left'">
          <fw-button (click)="openSearchForConflict()" variant="ghost" color="primary"
            [leftIcon]="'open'">{{ 'conflictFiles.details.viewInSearch' | translate }}</fw-button>
        </fw-tooltip>
      </fw-section-heading>
    </div>
  </div>
</div>
